import React from "react";

const ArrowSVG =()=>{

  return(
    <svg viewBox="0 0 64 64" height='36' width='36' fill='white' >
      <path d="M17.8 6.6c8.1 9.3 16.1 18.6 24.2 27.9v-4.2c-8.1 9-16.1 18.1-24.2 27.1-2.6 2.9 1.7 7.1 4.2 4.2 8.1-9 16.1-18.1 24.2-27.1 1.1-1.3 1.1-3 0-4.2C38.2 21 30.1 11.7 22 2.4c-2.5-2.9-6.7 1.3-4.2 4.2z"/>
    </svg>
  );
};

export default ArrowSVG;



// WEBPACK FOOTER //
// ./src/images/ArrowSVG.js